<template>
  <div class="list-wrapper">
      <div class="list media-list">
      <ul>
        <li :key="index" v-for="(item,index) in listItems">
          <a href="#" class="item-link item-content">
            <div
              class="item-media"
              v-if="IsImageShow(item.imageName)"
              style="align-self: flex-start;">
              <div class="cover-background list-image" :style="ImageStyle(item.imageName)"></div>
            </div>
            <div class="item-inner">
              <div class="item-title-row">
                <div
                  class="item-title"
                  :style="titleStyle"
                  v-if="item.title != ''">
                  {{item.title}}
                </div>
                <div
                  class="item-after"
                  :style="tagStyle"
                  v-if="item.tag != ''">
                    <a>{{item.tag}}</a>
                </div>
              </div>
              <div
                class="item-text ql-editor"
                :style="descriptionStyle"
                v-if="item.description != ''"
                v-html="item.description">
              </div>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import { IsNullOrEmpty } from '@/modules/helper/index'
  export default {
    props: {
      titleFontFace: {
        type: String,
        default: 'inherit'
      },
      descriptionFontFace: {
        type: String,
        default: 'inherit'
      },
      tagFontFace: {
        type: String,
        default: 'inherit'
      },
      listItems: {
        type: Array,
        default: []
      }
    },
    computed: {
      titleStyle() {
        return {
          'font-family': this.titleFontFace
        }
      },
      descriptionStyle() {
        return {
          'font-family': this.descriptionFontFace
        }
      },
      tagStyle() {
        return {
          'font-family': this.tagFontFace
        }
      }
    },
    methods: {
      ImageStyle: function(value) {
        return {
          'background-image': `url(${this.$store.getters.AppConfig.Urls.ContentAssetsBaseUrl + value})`
        }
      },
      IsImageShow: function(value) {
        return !IsNullOrEmpty(value)
      }
    }
  }
</script>
<style scoped>
  .list-wrapper .list.media-list .item-link .item-title-row {
    padding-right: 0px;
    background-size: 0px;
    background-image: none;
  }
  .list .item-text {
    overflow: initial!important;
    height: initial!important;
    text-overflow: initial!important;
    -webkit-line-clamp: initial!important;
    max-height: initial!important;
    display: initial;
  }
  /* .list-wrapper{
    padding: 10px 0px!important;
  } */
  .list {
    margin: 0px!important;
  }
  .ql-editor{
    padding: 5px 0px!important;
  }
  .list-image{
    height: 75px;
    width: 75px;
    margin-top: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/stacked-elements/content-control/List.vue